import { Brand } from '@blade/std-lib'

export const OAuthCodeTypeId = 'tradebot-tma/OAuthCode'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OAuthCodeTypeId = typeof OAuthCodeTypeId

export type OAuthCode = Brand.Branded<string, OAuthCodeTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OAuthCode = Brand.nominal<OAuthCode>()
